(function bespokeTabPrices() {
  'use strict';

  var PRICE_CLASS = 'bespoke-tab-price';
  var updateQueued = false;

  if (window.bespokeTabPricesInitialized) return;
  window.bespokeTabPricesInitialized = true;

  function getPrice(text) {
    var match = String(text || '').match(
      /(?:\u00a3|&pound;)\s*([\d,]+(?:\.\d{1,2})?)/i
    );

    return match ? '\u00a3' + match[1] : null;
  }

  function readPrice(container, selector) {
    var element = container.querySelector(selector);

    return element ? getPrice(element.textContent) : null;
  }

  function setTabPrice(container, tabSelector, price) {
    if (!price) return;

    var link = container.querySelector(tabSelector + ' > a');
    if (!link) return;

    var priceLine = link.querySelector('.' + PRICE_CLASS);

    if (!priceLine) {
      priceLine = document.createElement('span');
      priceLine.className = PRICE_CLASS;
      priceLine.innerHTML = 'from <strong></strong>';
      link.appendChild(priceLine);
    }

    var priceValue = priceLine.querySelector('strong');

    if (priceValue.textContent !== price) {
      priceValue.textContent = price;
      priceLine.setAttribute('aria-label', 'from ' + price);
    }
  }

  function initialise() {
    var container = document.querySelector('.m2m-fabric-options');
    if (!container) return;

    function updateTabPrices() {
      updateQueued = false;

      setTabPrice(
        container,
        '.bespoke-header-fabric',
        readPrice(container, '#fabric-product .price-t11-fabric h3')
      );

      setTabPrice(
        container,
        '.bespoke-header-curtain',
        readPrice(container, '#curtains-product .curtains_from_price .from')
      );

      setTabPrice(
        container,
        '.bespoke-header-blind',
        readPrice(container, '#blinds-product .blinds_from_price .from')
      );
    }

    function queueUpdate() {
      if (updateQueued) return;

      updateQueued = true;
      window.requestAnimationFrame(updateTabPrices);
    }

    updateTabPrices();

    var observer = new MutationObserver(queueUpdate);
    observer.observe(container, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
